export const AIRPORT_TYPE = 'AIRPORT'

export const stopsLabel = {
  nonStop: 'nonstop',
  oneStop: '1 stop',
  stops: 'stops',
}

export const productMap = { FLY: 'Flight', STAY: 'Hotel', DRIVE: 'Car' }

export const packageBasePath = '/shop/search'

export const APOLLO_CLIENT_NAME = 'm-fly-search'

export const DEFAULT_CHILD_AGE = 11
export const DEFAULT_INFANT_AGE = 0
